window.addEventListener("DOMContentLoaded", (event) => {

  
  function checkDay() {
    var dayInE = document.getElementsByClassName("deliveryDayValue");
    if(dayInE.length > 0) {
      var delDay = document.querySelector(".deliveryDayValue").value;
      if(delDay != "") {
        document.querySelector(".proxy-checkout").classList.add("hide");
        document.querySelector(".true-checkout").classList.add("show");
      if (delDay == 'Saturday' || delDay == 'Sunday') {
        console.log("Weekned!");
        document.getElementById("bb-cart-msg-bg").classList.add("active");
        checkXDayFun();
        
        return;
      }
      }
      }
    checkDayFun();
  }
  
  function checkDayFun() {
    setTimeout(function(){
     checkDay();
    }, 1000);
  }
  
  checkDayFun();




  function checkXDay() {
    var dayInE = document.getElementsByClassName("deliveryDayValue");
    if(dayInE.length > 0) {
      var delDay = document.querySelector(".deliveryDayValue").value;
      if(delDay != "") {
        document.querySelector(".proxy-checkout").classList.add("hide");
        document.querySelector(".true-checkout").classList.add("show");
      if (delDay != 'Saturday' && delDay != 'Sunday') {
        console.log("Inside!");
        checkDayFun();
        return;
      }
      }
      }
    checkXDayFun();
  }
  
  function checkXDayFun() {
    setTimeout(function(){
     checkXDay();
    }, 1000);
  }

  const closeCartMsg = document.getElementById('bb-cart-msg-confirm');
  if (closeCartMsg) {
  closeCartMsg.addEventListener('click', function(){
    console.log("Accepted!");
    document.getElementById("bb-cart-msg-bg").classList.remove("active");
  });
}

  document.getElementsByClassName('proxy-checkout')[0].addEventListener('click', function(){
    document.getElementById("bb-select-date-bg").classList.add("active");
  });
  
  const closeDateMsg = document.getElementById('bb-select-date-confirm');
  if (closeDateMsg) {
  closeDateMsg.addEventListener('click', function(){
    document.getElementById("bb-select-date-bg").classList.remove("active");
  });
}

});